import React, { useState } from 'react';
import styled from 'styled-components';
import { mediaQuery, typeStyle } from '@carvana/showroom-css-theme';
import { Config } from 'src/headerConfig';
import { Close, Logo, Menu } from './icons';
import NavItem from './NavItem';
import SigninButton from './SigninButton';

const MobileMenuContainer = styled.div`
  margin-right: 24px;
  ${mediaQuery('l')} {
    display: none;
  }
`;

const MobileMenuContent = styled.div`
  background: var(--cvna-color-white);
  transform: translate(0, 0);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MobileMenuHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px 19px 24px;
`;

const MobileNavContainer = styled.div`
  flex-grow: 1;
`;

const MobileFooterItem = styled.div`
  width: 100%;
  background: var(--cvna-color-grey-1);
  padding: 24px 32px;
`;

const SupportContactLink = styled.a`
  ${typeStyle('label-m')};
  margin: 0;
  color: var(--cvna-color-blue-6);
  transition: color 150ms ease-in-out;
  :hover {
    text-decoration: none;
    color: var(--cvna-color-blue-2);
  }
`;

const CloseContainer = styled.button`
  background: transparent;
  border: none;
`;

type MobileMenuProps = {
  config: Config;
  useAuth?: boolean;
  onSignin?(): void;
}


const MobileMenu = (props: MobileMenuProps) => {
  const { config, onSignin, useAuth } = props;
  const [isOpen, setIsOpen] = useState(false);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return (
    <MobileMenuContainer>
      <Menu onClick={open} />
      {isOpen && (
        <MobileMenuContent>
          <MobileMenuHeader>
            <Logo />
            <CloseContainer onClick={close}>
              <Close />
            </CloseContainer>
          </MobileMenuHeader>
          <MobileNavContainer>
            <NavItem key='home' label='home' href={config.home?.url || '/'} />
            {config.navigation?.map(({ label, url, childItems }) => (
              <NavItem
                key={label}
                label={label}
                href={url}
                childItems={childItems}
              />
            ))}
          </MobileNavContainer>
          {config.supportContact?.display && (
            <MobileFooterItem>
              <SupportContactLink href={config.supportContact?.url}>
                Support &amp; Contact
              </SupportContactLink>
            </MobileFooterItem>
          )}
          <MobileFooterItem>
            {useAuth && <SigninButton onSignin={onSignin}/>}
          </MobileFooterItem>
        </MobileMenuContent>
      )}
    </MobileMenuContainer>
  );
};

MobileMenu.defaultProps = {
  useAuth: false,
  // eslint-disable-next-line no-console
  onSignin: () => { console.log('Unimplemented onSignin method called')}
};
export default MobileMenu;